
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.customer-story-hero {
  display: grid;
  grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
  justify-content: center;

  img,
  video {
    max-width: 100%;
  }
}

.customer-story-hero__wrapper {
  grid-column: content;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: [content] 1fr [image] 1fr;
  align-items: center;
  max-width: $container-max-width;
  margin: 0 auto;
}

.customer-story-hero__content {
  grid-column: content / span 2;
  text-align: center;
}

.customer-story-hero__asset-container {
  position: relative;
  padding: 25px;
  grid-column: content / span 2;
  text-align: center;
}

.customer-story-hero__eyebrow {
  margin-bottom: 20px;
  text-transform: uppercase;
}

h1.customer-story-hero__heading {
  margin-bottom: 15px;
}

.customer-story-hero__subheading {
  max-width: 450px;
  margin: 0 auto;
}

.customer-story-hero__asset {
  position: relative;
  display: inline-block;
}

.customer-story-hero__play-icon {
  position: absolute;
  z-index: 3;
  width: 13%;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  cursor: pointer;
}

@include media-query(desktop) {
  h1.customer-story-hero__heading {
    margin-bottom: 30px;
  }

  .customer-story-hero__subheading {
    margin-bottom: 20px;
    margin-left: 0;
  }

  .customer-story-hero__content {
    grid-column: content;
    text-align: left;
  }

  .customer-story-hero__asset-container {
    grid-column: image;
    text-align: left;

    img {
      border-radius: 25px;
    }
  }
}

.customer-story-hero--video {
  margin-bottom: -20px;

  .customer-story-hero__content,
  .customer-story-hero__asset-container,
  .customer-story-hero__subheading {
    grid-column: content / span 2;
    margin: 0 auto;
    max-width: 740px;
    text-align: center;
  }

  .customer-story-hero__asset-container {
    max-width: 840px;
    margin-top: -30px;
  }

  .customer-story-hero__subheading {
    max-width: 450px;
    font-size: 14px;
    margin-top: -10px;
  }

  .customer-story-hero__asset-container {
    padding: 30px;
  }
}
`